import React from "react";
import ReactSelect from "@ui/ReactSelect";
import { useCategoryInput } from "./useCategoryInput";

interface P {
  focusableRef: React.RefObject<{
    focus: () => void;
  }>;
  name: string;
  placeholder: string;
  entry: { failureCategoryId: string | null };
  column: string;
  allowCategoryCreation?: boolean;
  setDirty: (dirty: boolean, column: string) => void;
}

const CategorySelect = ({
  name,
  placeholder,
  setDirty,
  entry,
  allowCategoryCreation = false,
  ...props
}: P) => {
  const categories = useCategoryInput(entry);

  React.useEffect(() => {
    setDirty(categories.dirty, props.column);
  }, [categories.dirty, props.column, setDirty]);

  return (
    <ReactSelect
      {...props}
      menuPortalTarget={window.document.body}
      ref={props.focusableRef as React.RefObject<HTMLDivElement>}
      name={name}
      placeholder={placeholder}
      value={categories.selectedCategory}
      options={categories.categoryOptions}
      onChange={categories.handleCategoryChanged}
      onCreate={allowCategoryCreation ? categories.handleCategoryCreated : undefined}
      onEdit={allowCategoryCreation ? categories.handleCategoryEdited : undefined}
      onDelete={allowCategoryCreation ? categories.handleCategoryDeleted : undefined}
    />
  );
};

export default React.memo(CategorySelect);
